import { UtilizationResult } from "./utilization";

export interface IHashObj {
  [key: string]: number;
}

export interface IAvailabilityDays {
  dayOfWeek: string;
  startIndex: number;
  endIndex: number;
}

export interface IShouldBeComponent {
  [key: string]: string[];
}

export interface IAddress {
  [key: string]: string;
}

export interface IMarkerData {
  id: string;
  entityType: string;
  pos: {
    lat: number;
    lng: number;
  };
  fullAddress: string;
  name: string;
  utilization: UtilizationResult;
}

export interface IMemoizedIndex {
  [key: string]: number;
}

export interface IDaysOfWeek {
  dateNumber: number;
  day: number;
  dateMonth: number;
  dateYear: number;
}

export interface IMousePosition {
  x: number;
  y: number;
}

export interface ITempSelectedDays {
  dayOfWeek: string;
  startTime: string;
  endTime: string;
}

export interface IHeatMapDate {
  date: string;
  time: string;
}

export interface IAddressWithLocation {
  fullAddress: string;
  lat: number;
  lng: number;
}

export interface ICenter {
  lat: number;
  lng: number;
}

export enum TranslationStatus {
  Pending = "Pending",
  Success ="Success",
  Failed = "Failed",
  Ignored = "Ignored" //source=target, no need to translate!
};